<template>
	<div>
		<section class="hero-wrap hero-wrap-2 " data-stellar-background-ratio="0.5">
			<div class="overlay">
				<img src="@/assets/images/bannerin.jpg" class="hero-wrap-img" importance="high" @load="imgLoad()" />
			</div>
			<div class="container">
				<div class="row no-gutters slider-text align-items-end justify-content-start">
					<div class="col-md-9  pb-5">
						<h1 class="mb-3 bread">{{ title }}</h1>
					</div>
				</div>
			</div>
		</section>
		<section class="ftco-section" v-if="typeData == '8'">
			<div class="AboutUs-blurb">
				<div class="AboutUs-blurb-title" style="margin-top: 0;">
					<span>企业简介</span>
				</div>
				<div class="AboutUs-blurb-title-text">科技创新 质量优越 服务至上</div>
				<div class="container">
					<div class="row">
						<div class="col-md-6">
							<div class="AboutUs-blurb-img">
								<div style="flex: 5;">
									<img src="@/assets/images/AboutUs1.jpg" alt="" class="AboutUs-blurb-left-img" style="width: 100%; height: 295px;">
								</div>
								<div style="flex: 6.3; margin-left: 10px;">
									<img src="@/assets/images/AboutUs2.jpg" alt="" class="AboutUs-blurb-imgTop">
									<img src="@/assets/images/AboutUs3.jpg" alt="" class="AboutUs-blurb-imgLeft">
									<img src="@/assets/images/AboutUs4.jpg" alt="" class="AboutUs-blurb-imgRight">
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<el-scrollbar class="AboutUs-blurb-title-p">
								<p>山东孚岳电气有限公司是一家专业服务于电力行业的高科技企业。公司扎根于电力行业，以电力数字化、智能化为主要方向，涵盖数字安全、数字运维、智能作业、工程技术等领域。</p>
								<p>作为一家以高新技术为主导的企业，公司始终坚持以技术创新为核心的发展战略，先后通过了ISO9001质量管理体系、ISO14001环境管理体系、ISO45001职业健康安全管理体系的认证，并先后获得“淄博市英才计划”，“高新技术企业”，“淄博高新区高层次人才创业项目”，“泰山系列人才工程”，山东半岛自创区发展建设资金项目，淄博市瞪羚培育企业，山东省专精特新中小企业等荣誉称号，与山东理工大学共建了机器人与智能装备研发中心及工业机器人与智能计算机实验室，设有“研究生联合培养基地”，截至目前共取得专利证书106项。</p>
								<p>孚岳电气是集“工程设计、科技研发、软件开发、产品制造、机电安装、系统集成和运维服务”为一体的专业化服务商。公司取得了电力工程施工总承包二级资质、电力承装修试三级资质、施工劳务不分等级资质、安全生产许可证等资质证书，是一家高度重视自主创新和研发投入的、持续进行精益生产和自动化生产线建设的、具备现代科学管理理念的智能制造企业。</p>
							</el-scrollbar>
						</div>
					</div>
				</div>
			</div>


			
			<div class="AboutUs-Culture">
				<div class="AboutUs-blurb-title">
					<span>企业文化</span>
				</div>
				<div class="AboutUs-blurb-title-text">电力行业整体解决方案供应商</div>
				<div class="AboutUs-Culture-div">
					<div class="container">
						<p class="culture_contit">【经营理念】</p>
						<p class="culture_contex">为客户提供体验优越、性能良好、稳定可靠</p>
						<p class="culture_contex">的软硬件产品和全方位的专业化服务，</p>
						<p class="culture_contex">努力打造能源互联网优秀品牌。</p>
						<p class="culture_contit">【团队使命】</p>
						<p class="culture_contex">以客户为中心，</p>
						<p class="culture_contex">以技术为驱动，</p>
						<p class="culture_contex">以发展为目标。</p>
						<p class="culture_contit">【 核心价值观】</p>
						<p class="culture_contex">诚信合作、服务至上</p>
						<p class="culture_contex">科技创新、勇于超越</p>
						<p class="culture_contex">团结协作、尊重信任</p>
						<p class="culture_contex">言出必行、行则必果</p>
						<p class="culture_contit">【营销理念】</p>
						<p class="culture_contex">一流的产品、一流的服务</p>
						<p class="culture_contit">【企业作风】</p>
						<p class="culture_contex">团结、拼搏、务实、高效</p>
						<p class="culture_contit">【企业使命】</p>
						<p class="culture_contex">精益求精，夯实核心技术</p>
						<p class="culture_contex">创新驱动，助力电力工业 腾飞。</p>
						<div style="clear: both;"></div>
					</div>
				</div>
			</div>
		</section>
			<section class="ftco-section testimony-section img" style="background-image: url(images/bg_1.jpg);" v-if="typeData == '9'">
			<div class="overlay"></div>
			<div class="container-index-list">
				<div class="row justify-content-center mb-5 pb-3">
					<div class="col-md-7 text-center heading-section heading-section-white ">
						<h2 class="mb-4">企业荣誉</h2>
					</div>
				</div>
				<div class="container-index-list">
					<div class=" honor_list">
						<div class="clearfix row d-flex justify-content-xl-between" style="color: #fff;" >
							<div class="col-lg-55 mb-4">
								<div class="honorimg">
									<div>
										<img src="@/assets/images/certificate.png" >
										2014-2015年 连续两年在淄博市 “初创企业”奖项
									</div>
									<div>
										<img src="@/assets/images/certificate.png" >
										2014年10月荣获国网山东省电力公司检修公司优秀供应商称号
									</div>
									<div>
										<img src="@/assets/images/certificate.png" >
										2015年11月顺利通过ISO9000质量管理体系认证
									</div>
								</div>
							</div>
							<div class="col-lg-55 mb-4">
								<div class="honorimg">
									<div>
										<img src="@/assets/images/certificate.png" >
										2017年通过国家级高新技术企业认定
									</div>
									<div>
										<img src="@/assets/images/certificate.png" >
										2017年荣获淄博市“三个一百”项目重点扶持企业之一
									</div>
								</div>
							</div>
							<div class="col-lg-55 mb-4">
								<div class="honorimg">
									<div>
										<img src="@/assets/images/certificate.png" >
										2018年通过了国家级高新技术企业认定
									</div>
									<div>
										<img src="@/assets/images/certificate.png" >
										2018年获得住建部认定的电力总承包、安全设计标准等资质
									</div>
									<div>
										<img src="@/assets/images/certificate.png" >
										2019年任崇广总经理荣获山东省泰山系列人才称号
									</div>
								</div>
							</div>
							<div class="col-lg-55 mb-4">
								<div class="honorimg">
									<div>
										<img src="@/assets/images/certificate.png" />
										2020年获得山东半岛自创区优秀企业称号
									</div>
									
									<div>
										<img src="@/assets/images/certificate.png" />
										2020年获得淄博市瞪羚培育企业称号
									</div>
									<div>
										<img src="@/assets/images/certificate.png" />
										2021年成为山东理工大学"科技副总"人才战略项目重点合作单位
									</div>
								</div>
							</div>
							<div class="col-lg-55 mb-4">
								<div class="honorimg">
									<div>
										<img src="@/assets/images/certificate.png" />
										2022年与山东理工大学共同设立研究生联合培养基地
									</div>
									<div>
										<img src="@/assets/images/certificate.png" />
										2023年获得山东省专精特新企业
									</div>
									<div>
										<img src="@/assets/images/certificate.png" />
										2024年获批山东省科技型中小企业创新能力提升工程项目
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row  justify-content-center">
				</div>
			</div>

		</section>

		<div class="AboutUs-expectation expectation" v-if="typeData == '9'">
			<div class="AboutUs-blurb-title">
				<span>展望未来</span>
			</div>
			<div class="container" style="text-align: center; padding-top: 50px; padding-bottom: 50px;">
				<p>在全球能源转型的大背景下，电力企业正站在一个充满机遇与挑战的十字路口。未来，我们可以预见到以下令人振奋的发展趋势和前景。</p>
				<p>能源多元化将成为电力企业发展的主旋律。随着可再生能源技术的不断进步，太阳能、风能、水能等清洁能源在电力供应中的比重将持续上升。电力企业将加大对这些领域的投资和研发，不断提高能源转化效率，降低成本，使清洁能源成为更加可靠和经济的能源选择。</p>
				<p>智能化电网将成为电力系统的核心架构。通过先进的传感器、通信技术和数据分析，电网将能够实现更高效的能源分配、实时监测和故障预警。这不仅能提高电力供应的稳定性和可靠性，还能更好地整合分布式能源资源，实现能源的优化利用。</p>
				<p>储能技术的突破将为电力行业带来革命性的变化。高效、大容量的储能系统将能够解决可再生能源的间歇性问题，使得电力的供应更加平稳和可持续。电力企业将积极探索和应用新型储能技术，如电池储能、超级电容储能等，为能源存储和释放提供更优解决方案。
电力企业的角色也将发生转变，从单纯的能源供应商向综合能源服务提供商拓展。除了提供电力，还将为用户提供能源管理、节能咨询、分布式能源系统集成等多元化的服务，满足用户日益增长的个性化能源需求。</p>
				<p>在国际合作方面，电力企业将更加积极地参与全球能源治理，加强与其他国家和地区的能源合作与交流。共同应对能源安全、气候变化等全球性挑战，推动建立更加公平、高效、可持续的国际能源秩序。</p>
				<p>未来的电力企业将以科技创新为驱动，以绿色发展为理念，以服务社会为己任。在能源转型的浪潮中勇立潮头，为人类创造一个更加清洁、智能、美好的能源未来。</p>
			</div>
		</div>


	</div>
</template>

<script>

	export default {
		data() {
			return {
				title: '',
				typeData: '',
			};
		},
		created() {},
		methods: {
			init() {
				// 企业简介
				if (this.typeData == '8') {
					this.title = '企业简介'
				} else if (this.typeData == '9') {
					this.title = '企业荣誉'
				} 
			}
		}
	};
</script>

<style scoped>
	/* .AboutUs-blurb-title{
		margin-top: 0;
	} */

	.AboutUs-Culture-div{
		min-height: 400px;
	}

	.culture_contit{
		font-size: 18px;
		/* margin-right: 50px; */
	}

	.culture_contex{
		font-size: 14px;
	}

</style>